export default "__VITE_PUBLIC_ASSET__00b502c0__"